import clsx from 'clsx';
import { Typography, Space, Col, Row, Container } from '@ag1/ui';
import { BenefitsTest as BenefitsTestProps, SanityKeyed } from 'types/studio/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { StudioBaseImageV2 } from '../StudioBaseImage/StudioBaseImage';
import { StudioBaseIconV2 } from '../StudioBaseIcon/StudioBaseIcon';
import CustomPortableText from '../PortableText/PortableText';
import styles from './BenefitsTest.module.scss';
import { CommonSectionProps } from '../types';

const BenefitsTest = ({
  variant,
  _key: key,
  headline,
  image,
  removeImageOnMobile,
  points,
  padding,
  visibleOnPageLoad
}: SanityKeyed<BenefitsTestProps> & CommonSectionProps) => {
  const wide = points.length % 2 === 1;

  return (
    <Container narrow id={key}>
      <Space
        top={{ xxs: 40, s: 60, m: 80, l: 100 }}
        bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
        className={clsx(getSectionPaddingClasses(styles, padding))}>
        <Row
          align={{ m: 'between' }}
          className={clsx(styles.row, variant === 'image_left' && styles.rowReverse)}>
          <Col span={{ xxs: 12, m: 6 }} className={styles.col}>
            {headline && (
              <Typography
                variant="headlineSans"
                size="2"
                component="div"
                color="black-new"
                className={clsx(removeImageOnMobile && styles.noPadding, styles.title)}
                noPadding>
                <CustomPortableText value={headline} />
              </Typography>
            )}
            <Row className={clsx(styles.itemRow, wide && styles.wide)}>
              {points.map(({ icon, iconBg, sellingpoint, _key }) => (
                <Col span={{ xxs: 12, s: 6 }} key={_key} className={clsx(styles.item)}>
                  {icon?.asset && (
                    <div className={clsx(styles.itemIcon, iconBg === 'white' && styles.white)}>
                      <StudioBaseIconV2 icon={icon} className={styles.icon} />
                    </div>
                  )}
                  <div>
                    {sellingpoint && (
                      <Typography
                        variant="headlineSans"
                        component="div"
                        size="3"
                        noPadding
                        className={styles.itemSubtitle}>
                        <CustomPortableText value={sellingpoint} />
                      </Typography>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
          {image?.image && (
            <Col span={{ xxs: 12, m: 6, l: 5 }}>
              <StudioBaseImageV2
                image={image.image}
                mobileImage={image.mobileImage}
                tabletImage={image.tabletImage}
                withMobileImage={image.withMobileImage}
                className={clsx(
                  styles.imageCont,
                  variant === 'image_left' && styles.imageContReverse,
                  removeImageOnMobile ? styles.displayNone : ''
                )}
                childClassName={styles.image}
                sizes={{ xxs: 12, m: 6, l: '600px' }}
                eagerLoading={visibleOnPageLoad}
              />
            </Col>
          )}
        </Row>
      </Space>
    </Container>
  );
};
export default BenefitsTest;
